import React from 'react';

type StepContainerProps = {
  heading: string;
  subheading: string;
  children: React.ReactNode;
  error?: string;
};

const StepContainer = ({ heading, subheading, children, error }: StepContainerProps) => (
  <>
    <div className="heading">{heading}</div>
    <div className="subheading">{subheading}</div>
    {children}
    {error && <div className="error mb2">{error}</div>}
  </>
);

export default StepContainer;
